'use client';

import { Content, asText } from '@prismicio/client';

import { Box, Heading } from '@preventx/oxygen';
import { RichText } from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { VimeoContainer } from '@/components/Display/VimeoContainer';

type WithVimeoProps = {
  slice: Content.RegionSliceWithVimeo;
};

export const WithVimeo = ({ slice }: WithVimeoProps) => {
  const { primary } = slice;
  const { title, content, video_id, video_position, video_caption } = primary;

  const { WebsiteUrl } = applicationEnv();

  return (
    <Box
      addFlow
      component="div"
      addSwitcher={video_position === 'Left' || video_position === 'Right'}
    >
      {(video_position === 'Top' || video_position === 'Left') && (
        <VimeoContainer
          caption={video_caption}
          vimeoId={video_id ?? undefined}
        />
      )}

      <Box component="div" addFlow>
        <Heading component="h2" addHeadlineTitle>
          {asText(title)}
        </Heading>

        <RichText content={content} variant="default" websiteUrl={WebsiteUrl} />
      </Box>

      {(video_position === 'Default' ||
        video_position === 'Bottom' ||
        video_position === 'Right') && (
        <VimeoContainer
          caption={video_caption}
          vimeoId={video_id ?? undefined}
        />
      )}
    </Box>
  );
};
